const shouldBypass = (src) => {
  if (!src || typeof src !== "string") return true;
  return src.startsWith("data:") || src.startsWith("blob:");
};

// Drops a prior t= so a new bust can be applied without stacking.
export const stripCacheBuster = (src) => {
  if (shouldBypass(src)) return src;
  try {
    const url = new URL(src);
    if (!url.searchParams.has("t")) return src;
    url.searchParams.delete("t");
    const query = url.searchParams.toString();
    return `${url.origin}${url.pathname}${query ? `?${query}` : ""}${url.hash}`;
  } catch {
    return src.replace(/([?&])t=\d+/g, (match, sep, offset, full) => {
      if (sep === "?" && full.includes("&", offset + match.length)) return "?";
      return "";
    }).replace(/\?&/, "?").replace(/[?&]$/, "");
  }
};

// Appends t= so an in-place CDN overwrite reloads; strips any existing t= first.
export const withCacheBuster = (src, buster) => {
  if (shouldBypass(src)) return src;
  const stripped = stripCacheBuster(src);
  const separator = stripped.includes("?") ? "&" : "?";
  const token = buster == null ? Date.now() : buster;
  return `${stripped}${separator}t=${token}`;
};
